module.exports = __webpack_public_path__ + "img/2en.7a9ecba1.png";